import {connect} from "react-redux";
import Video from '../../components/Video/Video';
import * as VideoActions from "../../store/actions/videoActions";
import * as AuthActions from '../../store/actions/authActions';

const mapStateToProps = (state) => ({
    ...state.auth,
    ...state.video
});

const mapDispatchToProps = (dispatch) => ({
    onLoad: (profileId, subjectId, courseId, token) => {
        dispatch(VideoActions.getTestCourse(courseId, token));
        dispatch(VideoActions.getUserSubject(profileId, courseId, subjectId, token));
        //dispatch(VideoActions.getCourseUser(profileId, token));

        dispatch(VideoActions.getVideoDescription());
    },
    updateCourseUser: (courseUser, token, profileId) => {
        //dispatch(AuthActions.setCourseUserNextStep(courseUser, token));
        dispatch(VideoActions.updateCourseUser(courseUser, profileId, token))
    },
    focusLecture: (id, token, profileId) => {
        dispatch(VideoActions.getUserChapterPart(id, token));
        dispatch(VideoActions.getUserVideoQuestions(id, profileId, token));

    },
    getCompletedUserLectures: (usid, token) => {
        dispatch(VideoActions.getCompletedUserLectures(usid, token));
    }

});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Video);


// WEBPACK FOOTER //
// ./src/containers/Video/VideoContainer.js